export class ContextScopeError extends Error {
  public constructor(hook: string, provider: string) {
    super(`${hook} must be used within a <${provider} />`);
  }
}
